import { Add } from '@mui/icons-material';
import { Box } from '@mui/material';

import { Button } from '@/components';
import { NEW_FEATURE_ALERTS } from '@/constants';
import { NewFeatureTooltip } from '@/containers';
import { useNewFeatureAlert } from '@/hooks';
import { useFetchPlanLimitsQuery } from '@/store';

import { isUnderSeatCap } from '../utils';
import { SeatCapProgressIndicator } from './SeatCapProgressIndicator';

interface InviteMembersButtonProps {
  onClick: () => void;
  activeMemberEmails: string[];
}
const ALERT_ID = NEW_FEATURE_ALERTS.INVITE_MEMBERS_TOOLTIP;

export const InviteMembersButton = ({
  onClick,
  activeMemberEmails,
}: InviteMembersButtonProps) => {
  const { data: planLimits } = useFetchPlanLimitsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const activeMemberCount = activeMemberEmails.length;

  const newFeatureAlert = useNewFeatureAlert(ALERT_ID);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <SeatCapProgressIndicator
        count={activeMemberCount}
        cap={planLimits?.seatCap?.seatCap}
        hasError={false}
      />
      <NewFeatureTooltip
        id={ALERT_ID}
        featureName="Invite members"
        featureDescription="Invite additional members to your team via email or by importing a CSV file."
        placement="bottom-end"
        isVisible={newFeatureAlert.isVisible}
        onDismiss={newFeatureAlert.dismiss}>
        <Button
          label="Invite"
          aria-label="Invite Members"
          onClick={() => {
            onClick();
            newFeatureAlert.dismiss();
          }}
          startIcon={<Add />}
          fullWidth={false}
          disabled={
            !planLimits || !isUnderSeatCap(planLimits, 1, activeMemberCount)
          }
        />
      </NewFeatureTooltip>
    </Box>
  );
};
